import { render } from "./UiOneCheckbox.pug?vue&type=template&id=6e8fc806&lang=pug"
import script from "./UiOneCheckbox.js?vue&type=script&lang=js"
export * from "./UiOneCheckbox.js?vue&type=script&lang=js"

import "./UiOneCheckbox.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__